import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { LayoutDashboard, Users, Settings, FileText, ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

const navItems = [
  { key: 'dashboard', path: '/', icon: LayoutDashboard },
  { key: 'clients', path: '/clients', icon: Users },
  { key: 'documents', path: '/documents', icon: FileText },
  { key: 'settings', path: '/settings', icon: Settings },
];

export default function Sidebar({ open, onToggle }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useLanguage();

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <aside
      className={cn(
        "bg-slate-900 dark:bg-slate-950 text-white flex flex-col shrink-0 transition-all duration-300 ease-in-out",
        open ? "w-60" : "w-[68px]"
      )}
      data-testid="sidebar"
    >
      <div className="h-16 flex items-center justify-between px-4 border-b border-slate-800">
        {open && (
          <span className="text-base font-bold tracking-tight whitespace-nowrap" style={{ fontFamily: 'Manrope, sans-serif' }}>
            KGP & Co.
          </span>
        )}
        <button
          onClick={onToggle}
          className={cn("p-1.5 rounded-lg hover:bg-slate-800 transition-colors", !open && "mx-auto")}
          data-testid="sidebar-collapse-btn"
        >
          {open ? <ChevronLeft className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
        </button>
      </div>

      <nav className="flex-1 py-3 space-y-0.5">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          return (
            <button
              key={item.key}
              onClick={() => navigate(item.path)}
              className={cn(
                "w-full flex items-center gap-3 px-4 py-2.5 text-sm transition-colors duration-200",
                active
                  ? "bg-blue-600/90 text-white font-medium"
                  : "text-slate-400 hover:bg-slate-800 hover:text-white",
                !open && "justify-center px-0"
              )}
              data-testid={`nav-${item.key}`}
              title={!open ? t(item.key) : undefined}
            >
              <Icon className="h-5 w-5 shrink-0" />
              {open && <span>{t(item.key)}</span>}
            </button>
          );
        })}
      </nav>

      <div className="p-4 border-t border-slate-800">
        {open && (
          <p className="text-[11px] text-slate-500 text-center">
            CA Practice Management
          </p>
        )}
      </div>
    </aside>
  );
}
